import { render, staticRenderFns } from "./MypagetTicketCloseIconParts.vue?vue&type=template&id=4b5d8046&scoped=true"
import script from "./MypagetTicketCloseIconParts.vue?vue&type=script&lang=ts"
export * from "./MypagetTicketCloseIconParts.vue?vue&type=script&lang=ts"
import style0 from "./MypagetTicketCloseIconParts.vue?vue&type=style&index=0&id=4b5d8046&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d8046",
  null
  
)

export default component.exports